<template>
  <b-dropdown right
              variant="link"
              no-caret
              v-if="!rights.includes('hide_patient_phone')"
              class="d-inline-block align-middle">
    <template #button-content>
      <a class="pointer position-relative"
         :class="[{ 'ml-3': view === 'patientCard' }, aClass]"
         :style="topPosition !== null ? `top: ${topPosition}px` : (view === 'patientCard' ? 'top: -3px' : 'top: -2px')"
         v-b-tooltip.hover
         :title="$t('write_in_messenger')">
        <WhatsappSvg :class="iconClass" style="width: 16px;"/>
        <span class="action-button-mob-title">{{ $t('write_in_messenger') }}</span>
      </a>
    </template>

    <b-dropdown-item v-if="wazzupEnabled && patientId"
                     @click="wazzupIframe('whatsapp')">
      Whatsapp
    </b-dropdown-item>

    <b-dropdown-item v-if="wazzupEnabled && patientId"
                     @click="wazzupIframe('telegram')">
      Telegram
    </b-dropdown-item>

    <b-dropdown-item v-if="!wazzupEnabled || !patientId"
                     target="_blank"
                     :href="`https://wa.me/${formatPhone(phone, false)}`">
      Whatsapp
    </b-dropdown-item>

    <b-dropdown-item v-if="!wazzupEnabled || !patientId"
                     target="_blank"
                     :href="`https://t.me/${formatPhone(phone)}`">
      Telegram
    </b-dropdown-item>

    <b-dropdown-item v-if="jetAPILink && jetAPIPanelEnabled"
                     @click="launchJetorGreenAPISidebar('whatsapp')">
      Whatsapp ({{ $t('chat_panel') }})
    </b-dropdown-item>

    <b-dropdown-item v-if="jetAPILink && jetAPIPanelEnabled"
                     @click="launchJetorGreenAPISidebar('tdlib')">
      Telegram ({{ $t('chat_panel') }})
    </b-dropdown-item>

    <b-dropdown-item v-if="maxPanelEnabled"
                     @click="launchJetorGreenAPISidebar('max')">
      Max ({{ $t('chat_panel') }})
    </b-dropdown-item>

    <b-dropdown-item v-if="greenApiframeUrl && greenAPIWhatsappPanelEnabled"
                     @click="launchJetorGreenAPISidebar('whatsapp')">
      Whatsapp ({{ $t('chat_panel') }})
    </b-dropdown-item>

    <b-dropdown-item v-if="greenApiframeUrl && greenAPITelegramPanelEnabled"
                     @click="launchJetorGreenAPISidebar('telegram')">
      Telegram ({{ $t('chat_panel') }})
    </b-dropdown-item>

    <b-dropdown-item v-if="auraPanelEnabled"
                     @click="launchJetorGreenAPISidebar('whatsapp')">
      Whatsapp ({{ $t('chat_panel') }})
    </b-dropdown-item>
  </b-dropdown>
</template>

<script setup>
import { WhatsappService } from "@/services/api/whatsapp.api.service"
import WhatsappSvg from "@/assets/svg-vue/crm/whatsapp.svg"
import { useStore } from "vuex"
import {formatPhone} from "@/extensions/filters/filters"
import {computed, getCurrentInstance, nextTick, onBeforeMount} from "vue"

const props = defineProps({
  patientId: {},
  phone: {},
  view: {
    type: String,
    default: 'patientCard'
  },
  aClass: {
    type: String,
    default: ""
  },
  topPosition: {
    type: Number,
    default: null
  }
})

const store = useStore()
let bvModal = null
let noty = null

const getters = store.getters
const rights = computed(() => store.state.auth.rights)
const wazzupEnabled = computed(() => store.state.crm.wazzupEnabled)
const dynamicConfigValue = computed(() => store.getters.dynamicConfigValue)
const iconClass = computed(() => props.view === 'crm' ? 'svg-light' : 'svg-primary')
const jetAPILink = computed(() => store.getters.jetAPIEnabled ? dynamicConfigValue.value('jetapi_iframe_url') : null)
const jetAPIPanelEnabled = computed(() => store.getters.jetAPIPanelEnabled)
const greenAPIWhatsappPanelEnabled = computed(() => getters.greenAPIPanelEnabled)
const greenAPIMaxPanelEnabled = computed(() => getters.greenAPIMaxPanelEnabled)
const greenAPITelegramPanelEnabled = computed(() => getters.greenAPITelegramPanelEnabled)
const maxPanelEnabled = computed(() => jetAPIPanelEnabled.value || greenAPIMaxPanelEnabled.value)
const auraPanelEnabled = computed(() => store.getters.auraPanelEnabled)
const greenApiframeUrl = computed(() => store.getters.greenAPIIframeUrl(props.phone))

const wazzupIframe = async (type = 'whatsapp') => {
  let res = await WhatsappService.createIframe(props.patientId, type)
  if(res.data.url) {
    store.commit('setWazzupIframeUrl', res.data.url)
    await nextTick()
    bvModal.show('wazzup-iframe-modal')
    return
  }
  if(res.data.error) {
    noty.error(res.data.error)
  }
}

const launchJetorGreenAPISidebar = (channel = 'whatsapp') => {
  store.commit('setPhoneForJetApi', {
    phone: formatPhone(props.phone, false, true),
    channel
  })
  store.commit('setMessengerPanelPlatform', channel)
  store.commit('setRightPaneOpened', true)
}

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.proxy?.$bvModal
  noty = instance?.appContext?.app?.noty
})
</script>
